import { Component, OnInit } from '@angular/core';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';
import { HelperService } from 'src/app/shared/helpers/helper.service';

@Component({
  selector: 'app-acceptable-use',
  templateUrl: './acceptable-use.component.html',
  styleUrls: ['./acceptable-use.component.scss']
})
export class AcceptableUseComponent implements OnInit {
  public useRebrandedLayout: boolean;

  constructor(
    public helperService: HelperService, 
    private featureFlagService: FeatureFlagsService 
  ){
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  ngOnInit(): void {}
}
